export const EmployeeContractEN = {
    "EmployeeContractAdd": {
        "EmployeeContractAdd": "Add CurrentEmployee Contract ",
        "EmployeeContractEdit": "Edit CurrentEmployee Contract  ",
        "EmployeeContractDelete": "Delete CurrentEmployee Contract",
        "ListEmployeeContract": "List CurrentEmployee Contract",
        "LiquidationEmployeeContract": "Liquidation CurrentEmployee Contract ",
        "ApprovalEmployeeContract": "Approval CurrentEmployee Contract",
        "QuickView": "Quick content",
        "undoApproval": "Undo approval "
    },
    "EmployeeContractTitle": {
        "employeeContractId": "Contract Code",
        "fullName": "full name",
        "CurrentDepartment": "Department ",
        "signDay": "Sign day",
        "effectiveDate": "Effective from the date",
        "tillDate": "To date ",
        "Status": "Status ",
        "StatusQuo": "Status",
        "creator": "Creator ",
        "creatdate": "Date created ",
        "employeeId": "Employee",
        "contractId": "Contract",
        "form": "Employment Type",
        "position": "Job Position",
        "office": "Job Title",
        "workplace": "Work location",
        "signerId": "Signer",
        "FIle": "Attrack file",
        "glone": "Pay grade",
        "to": " To ",
        "description": "Note",
        "informationSalary": "Salary and allowances information",
        "informationGeneral": "General information",
        "notFound": "No salary and allowance information",
        "approved": "Approved",
        "liquidated": "Liquidation",
        "pending": "Pending",
        "end": "End",
        "Unsigned": "Unsigned",
        "ineffect": "In Effect",
        "expired": "Expired",
        "notyetvalid": "Not Yet Valid",
        "liquidation": "Liquidation ",
        "status": "Status",
        "contractName": "Contract name",
        "jobDetails": "Job details",
        "Working": "Working",
        "Waiting": "Waiting",
        "DropTemp": "DropTemp",
        "Resignation": "Resignation"
    },
    "placeholderEMC": {
        "employeeContractId": "Contract Code",
        "fullName": "Staff's name",
        "CurrentDepartment": "Department ",
        "signDay": "Sign day",
        "effectiveDate": "Effective from the date",
        "tillDate": "To date ",
        "Status": "Status ",
        "creator": "Creator ",
        "creatdate": "Date created ",
        "employeeId": "Search code , fullname...",
        "contractId": "Contract",
        "form": "Format",
        "position": "Job Position",
        "office": "Job Title",
        "workplace": "Work location",
        "signerId": "Signer",
        "FIle": "Attrack file",
        "signerDay": "Sing Day",
        "glone": "Pay grade",
        "since": "Since",
        "Note": "Note",
        "Salaryform": "Salary form ",
        "Amountofmoney": "Amount of money",
        "Allowance": "Allowance"
    },
    "buttonEMC": {
        "buttonSubmit": "Create",
        "buttonUpdate": "Update",
        "buttonCancel": "Cancel",
        "buttonKeep": "Keep the page after",
        "buttonGo": "Go to the list after",
        "approve": "Approve",
        "agree": "Agree"
    },
    "NotificationEmployeeContract": {
        "edit": "Edit data successfully",
        "add": "Add data successfully",
        "delete": "Delete data successfully",
        "Liquidation": "Status update successful",
        "question": " Do you want to delete ? ",
        "questionApproval": "Do you want to approve this employee contract? ",
        "approval": "Approval successful",
        "titleApproval": "Approval employee contract",
        "effectiveToSingDay": "Signing date must not be greater than contract end date",
        "effectiveToSince": "Salary and allowances from the date of contract must not be greater than the contract termination date",
        "effectiveFromSince": "Salary and allowances from the date must not be less than the contract start date",
        "effectiveFromEffectiveTo": "CurrentEmployee Contract expiration date after the effective date",
        "salaryError": "Salary form of the day ",
        "salaryError1": " do not overlap ",
        "AllowanceError": "Type of allowance of the day ",
        "updateSuccess": "successfully updated",
        "startDate": "Start date ( ",
        "notJoinDate": " ) must not be less than Working Day",
        "questionUndo": "Are you sure you want to undo approval? ",
        "duplicateDate": "Can't enter duplicate dates"

    },
    "EmployeeContract": {
        "search": "Search Profiles",
        "myApproval": "Contract you approve",
        "noDataResponse": "There is no result",
        "updateContract": "Edit contract",
        "addContract": "Add new contract",
        "add": "Add",
        "allContract": "All contracts",
        "approvalContract": "The contract is in effect",
        "noApprovalContract": "Contract expires",
        "oneYear": "One year contract",
        "threeYear": "Three-year contract",
        "internship": "Internship contract",
        "noContract": "No contract yet",
        "day": "Day",
        "approval": "In effect",
        "liquidation": "Contract liquidation",
    },
    "EmployeeCareer": {
        "startDate": "Start date",
        "department" : "Department",
        "jobPosition": "Job position",
        "jobTitle": "Job title",
        "jobTitleRequired" : "Title is required",
        "jobPositionRequired" : "Position is required",
        "departmentRequired" : "Department is required",
        "startDateRequired" : "Start date is required",
        "sinceRequired" : "Since is required",
        "since" : "Since",
        "deleteConcurrently" : "Remove part-time of personnel",
        "deleteCareer" : "Delete personnel's live updated job history",
        "createBy" : "Create by",
        "employeeContract": "Employee contract",
        "decisionTransfer": "Decision transfer",
        "decisionAdmission": "Decision admission",
        "decisionAppointment": "Decision appointment",
        "decisionDismissal": "Decision dismissal",
        "decisionContract": "Decision contract",
        "updatePosition": "Update position",
        "questionConcurrently" : "Are you sure you want to delete this concurrent employee?",
        "questionCareer" : "Are you sure you want to delete this HR direct position?",
        "startDateSalaryRequired" : "Start date is required",
        "startDateSalary": "Start date",
        "salaryForm": "Salary form",
        "salaryFormRequired": "Salary form is required",
        "amountOfMoney": "Amount of money",
        "amountOfMoneyRequired": "Amount of money is required",
        "allowance": "Allowance",
        "allowanceRequired": "Allowance is required",
        "deleteSalaryAllowance" : "Remove employees' salaries and allowances",
        "questionSalaryAllowance" : "Are you sure you want to delete this employee salary and allowance?",
        "startContract" : "History automatically spawns from the contract start date.",
        "endContract" : "History automatically spawns from the contract start date.",
        "contractLiquidation" : "History is automatically generated from the contract end date.",
        "updatePositionJob" : "History automatically generated from live updates.",
        "decisionContractTooltip" : "History is automatically generated from the termination decision.",
        "decisionDismissalTooltip" : "History is automatically generated from dismissal decisions.",
        "decisionAppointmentTooltip" : "History automatically spawns from appointment decisions.",
        "decisionAdmissionTooltip" : "History is automatically born from the decision to adopt.",
        "decisionTransferTooltip" : "History is automatically generated from the transfer decision.",
        "salaryContract" : "History automatically generated from the contract",
    }
}
